module.exports = __webpack_public_path__ + "img/goods8_4.b27fac01.jpg";